'use client';

import Popover, { PopoverProps } from './Popover';

export default function Modal(props: PopoverProps) {
  return <Popover {...{ ...props, displayAs: 'MODAL' }} />;
}
